import { useState } from "react";
import "../styles/challenge-theme-category-creation.css";
import { useNavigate } from "react-router-dom";
import Button from "../../../../ui/atoms/buttons/Button";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import InputTextArea from "../../../../ui/atoms/inputs/input-textarea/InputTextArea";
//
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
//
import { ChallengeThemeCategorySchema } from "../../../../core/utils/validators/challenge";
import { wait } from "../../../../core/utils/helpers";
import { onCreateChallengeThemeCategory } from "../../services/challengeTheme";
//
import Swal from "sweetalert2";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const ChallengeThemeCategoryCreation = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(ChallengeThemeCategorySchema),
  });

  const onSubmit = async (data) => {
    setIsSending(true);
    Swal.fire({
      title: "Creating new challenge theme category...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await wait(700);
    //
    onCreateChallengeThemeCategory(axiosPrivate, data)
      .then((response) => {
        const _data = response?.data;
        Swal.close();
        setIsSending(false);

        if (_data?.status) {
          Swal.fire({
            title: "Challenge Theme Category Creation",
            text: _data?.message,
            icon: "success",
            confirmButtonText: "OK",
            didOpen: () => {
              const btn = Swal.getConfirmButton(); //
              btn.style.backgroundColor = "#2840a8";
              btn.style.color = "white";
            },
          });
          reset();
        } else {
          Swal.fire({
            title: "Challenge Theme Category Creation",
            text: _data?.message,
            icon: "info",
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        Swal.close();
        if (!error?.response) {
          Swal.fire({
            title: "Challenge Theme Category Creation",
            text: "No server response",
            icon: "warning",
          });
        } else {
          Swal.fire({
            title: "Challenge Theme Category Creation",
            text: error?.response?.data?.detail?.message,
            icon: "error",
          });
        }
      });
  };

  return (
    <form
      className="challenge-theme-category-creation"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="c-t-c-cr-head">
        <button type="button" onClick={() => navigate(-1)}>
          ⬅️ Back to list
        </button>
        <div className="w-full d-flex justify-space-between align-center">
          <h1>🙎🏽 New Challenge Theme Category creation</h1>
          <Button
            type={isSending ? "button" : "submit"}
            preferedStyle={isSending ? "default" : "normal"}
            title={
              isSending
                ? "Creating new Challenge Theme Category..."
                : "Validate and Create new Challenge Theme Category"
            }
          />
        </div>
      </div>
      <div className="c-t-c-cr-body">
        <div className="w-full d-flex gap-md mb-lg">
          <div className="w-50">
            <InputText
              type={"text"}
              name={"title_en"}
              title={"Title in English"}
              error={errors?.title_en?.message}
              register={register}
            />
          </div>
          <div className="w-50">
            <InputText
              type={"text"}
              name={"title_fr"}
              title={"Title in French"}
              error={errors?.title_fr?.message}
              register={register}
            />
          </div>
        </div>
        <div className="w-full  d-flex gap-md">
          <div className="w-50">
            <InputTextArea
              name={"description_en"}
              title={"Description in English"}
              error={errors?.description_en?.message}
              register={register}
            />
          </div>
          <div className="w-50">
            <InputTextArea
              name={"description_fr"}
              title={"Description in French"}
              error={errors?.description_fr?.message}
              register={register}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default ChallengeThemeCategoryCreation;
